export default "__VITE_ASSET__Durauwu8__"